import { render, staticRenderFns } from "./DomicilioPagoComponent.vue?vue&type=template&id=bb530a7e&scoped=true"
import script from "./DomicilioPagoComponent.vue?vue&type=script&lang=js"
export * from "./DomicilioPagoComponent.vue?vue&type=script&lang=js"
import style0 from "./DomicilioPagoComponent.vue?vue&type=style&index=0&id=bb530a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb530a7e",
  null
  
)

export default component.exports